import * as React from "react";
import {useContext, useEffect, useState} from "react";
import AppContent from "../Surfaces/AppContent";
import AuthContext from "../Services/AuthContext";
import {DefaultButton, PrimaryButton, Stack} from "@fluentui/react";
import {Link} from "react-router-dom";
import {MoneyField} from "../Utilities/MoneyField";
import ProtocolPaymentList from "../Lists/ProtocolPaymentList";

function Payment() {
    const [user] = useContext(AuthContext);
    const [companies, setCompanies] = useState([]);
    const [payments, setPayments] = useState([]);
    const [refresh, setRefresh] = useState(0);

    const [filter, setFilter] = useState(null);
    const [filtered, setFiltered] = useState([]);


    const _choiceButtons = (item) => {
        if (item.id === filter) {
            return (<PrimaryButton key={item.id} onClick={() => setFilter(null)}>{item.name}</PrimaryButton>);
        }
        return (<DefaultButton key={item.id} onClick={() => setFilter(item.id)}>{item.name}</DefaultButton>);
    }




    useEffect(() => {
        setFilter(null);
        const abortController = new AbortController();
        async function fetchData() {
            await fetch("/api/payment", {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => { setPayments(data); })
                .catch(err => { console.log(err) })
        }
        fetchData();
        async function fetchCompanies() {
            await fetch("/api/company", {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => { setCompanies(data) })
                .catch(err => { console.log(err) })
        }
        fetchCompanies();
        return () => abortController.abort();
    }, [refresh]);

    useEffect(() => {

        let results = [];

        payments.forEach((i) => {
            if (i.company_id === filter || filter === null) {
                results.push(i);
            }
        });

        setFiltered(results);
    }, [filter, payments]);

    const columns = [
        {
            key: 'protocol_number',
            name: 'Numer protokołu',
            ariaLabel: 'Numer protokołu',
            fieldName: 'protocol_number',
            minWidth: 100,
            isRowHeader: true,
            isResizable: true,
            onRender: (item) => (<Link to={`/venture/${item.venture_id}/protocol/${item.protocol_id}`}><PrimaryButton text={item.protocol_number} /></Link>)
        },
        {
            key: 'agreement_number',
            name: 'Numer umowy',
            ariaLabel: 'Numer umowy',
            fieldName: 'agreement_number',
            minWidth: 100,
            isResizable: true,
            onRender: (item) => (<Link to={`/venture/${item.venture_id}/cost/${item.agreement_id}`}><DefaultButton text={item.agreement_number} /></Link>)
        },
        {
            key: 'venture_name',
            name: 'Kontrakt',
            ariaLabel: 'Nazwa kontraktu',
            fieldName: 'venture_name',
            minWidth: 250,
            isResizable: false,
        },
        {
            key: 'contractor_name',
            name: 'Wykonawca',
            ariaLabel: 'Nazwa wykonawcy',
            fieldName: 'contractor_name',
            minWidth: 200,
            isResizable: false,
        },
        {
            key: 'created',
            name: 'Utworzono',
            ariaLabel: 'Utworzono',
            fieldName: 'created',
            minWidth: 120,
            isResizable: false,
        },
        {
            key: 'deadline',
            name: 'Termin',
            ariaLabel: 'Termin',
            fieldName: 'deadline',
            minWidth: 120,
            isResizable: false,
        },
        {
            key: 'value',
            name: 'Wartość',
            ariaLabel: 'Wartość',
            fieldName: 'value',
            minWidth: 120,
            isResizable: false,
            ...MoneyField()
        },
    ];


    return (
        <AppContent title={'Płatności'}>
            <Stack  horizontal disableShrink horizontalAlign="center" tokens={{childrenGap: 'l1'}}>
                <span>{companies.map(_choiceButtons)}</span>
            </Stack>
            <ProtocolPaymentList refresh={()=>setRefresh(refresh+1)} columns={columns} data={filtered}/>
        </AppContent>
    );
}

export default Payment